import React, { Fragment } from 'react';
import { Row, Col, Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft, faArrowCircleRight, faLink, faRocket, faToolbox, faClipboardList, faDrum, faLightbulb, faLayerGroup, faCodeBranch, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { Loader, LoaderContainer } from '../../Loader';
import './DeliverableXs.css';
import '../Deliverable/Deliverable.css';

const DeliverableXs = (props) => {

  const getMediaComponent = (entry) => {

    if (!entry) return (<span>NO ENTRY HERE</span>);

    if (isYoutubeVideo(entry.url)) {
      return (
        <div className="jp-video-container-noxs">
          <div className="embed-responsive embed-responsive-16by9">
            <iframe className="embed-responsive-item" src={entry.url} title={entry.title} frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen></iframe>
          </div>
        </div>
      )
    }


    if (isImage(entry.url)) {

      let _className = "Deliverable__stationery img-responsive";
      if (entry.pageUrl) _className += " pointer";

      return (
        <img
          src={entry.url}
          className={_className}
          alt={entry.title}
          title={entry.title}
          onClick={() => { if (entry.pageUrl) openNewTab(entry.pageUrl); }} />
      )
    }
  }

  const getAttrHeadingIcon = (attrHeading) => {
    if (attrHeading === 'web technologies') return faRocket;
    if (attrHeading === 'attributes') return faClipboardList;
    if (attrHeading === 'tools') return faToolbox;
    if (attrHeading === 'gamification of music') return faDrum;
    if (attrHeading === 'dev stack') return faLayerGroup;
    if (attrHeading === 'contribution') return faCodeBranch;
    if (attrHeading === '3rd parties') return faLink;
    if (attrHeading === 'publication' || attrHeading === 'abstract') return faFileAlt;
    return faLightbulb;
  }

  const openNewTab = (pageUrl) => {
    window.open(pageUrl, '_blank');
  }

  const renderLoader = () => {
    return (
      <Row className="visible-xs">
        <Col sm={12}>
          <LoaderContainer>
            <Loader sizes={[100, 50]} spacer={5} />
            <Loader sizes={[100, 50]} spacer={5} />
            <Loader sizes={[100, 50]} spacer={5} />
          </LoaderContainer>
        </Col>
      </Row>
    );
  }

  const renderDeliverableXs = () => {

    let currentProject = props.project;

    return (

      <div className="fademein visible-xs">

        {/* Secondary nav and deliverables */}
        <Row>
          <Col xs={12}>
            <div className="DeliverableXs__nav">

              { /* Project deliverable item + media toggle */
                currentProject.deliverables.map((deliverable, deliverableIndex) => {

                  let activeClass = (props.activeTabIndex === deliverableIndex) ? 'isOpen' : '';

                  return (
                    <Fragment key={deliverableIndex}>

                      {/* Deliverable accordion toggle */}
                      {deliverable.label && <div
                        className={`DeliverableXs__nav__itemToggle ${activeClass}`}
                        onClick={(event) => props.handleDeliverableToggle(deliverableIndex, event)} >{deliverable.label.toUpperCase()}
                      </div>
                      }

                      <div className={`DeliverableXs__nav__itemContent ${activeClass} `}>

                        {/* Media content */}
                        <Row>
                          <Col xs={12} className="center-block">

                            {deliverable.media.type === 'CAROUSEL' &&
                              <div className="img-responsive jp-img-stationery jp-toggle-content">
                                <Carousel interval={null} className="bo-carousel">

                                  {deliverable.media.entries.map((entry, index) => {
                                    return (
                                      <Carousel.Item key={index}>
                                        <img src={entry.url} title={entry.title} alt={entry.title} onClick={() => { if (entry.pageUrl) openNewTab(entry.pageUrl); }} className={entry.pageUrl && "pointer"} />
                                      </Carousel.Item>
                                    )
                                  })}

                                </Carousel>
                              </div>
                            }

                            {(deliverable.media.type === 'TABS' || deliverable.media.type === 'IMG') &&
                              <div>
                                {getMediaComponent(deliverable.media.entries[props.activeMediaIndex])}
                              </div>
                            }

                          </Col>
                        </Row>

                        {/* Media toggle */}
                        {deliverable.media.type === 'TABS' && <Row>
                          <Col xs={12}>
                            <div className="Deliverable__toggleButtonsCtn">
                              {deliverable.media.entries.map((entry, mediaIndex) => {

                                let activeMediaClass = (props.activeMediaIndex === mediaIndex) ? 'Deliverable__toggleButton--active' : '';

                                return (
                                  <div
                                    className={`Deliverable__toggleButton ${activeMediaClass}`}
                                    key={mediaIndex}
                                    onClick={(event) => { props.handleMediaToggle(mediaIndex, event); }}>{entry.label}
                                  </div>)
                              })
                              }
                            </div>
                          </Col>
                        </Row>}



                        {/* Deliverable info */}
                        <Row>
                          <Col xs={12}>
                            <div className="Deliverable__leftItem">
                              {deliverable.label ? <h2 className="Deliverable__item__title">{deliverable.label}</h2> : null}
                              {deliverable.url ? <div className="Deliverable__item__url"><a href={`${deliverable.url}`} target="_blank">{deliverable.url}</a></div> : null}
                            </div>

                            {/* Component synopsis */}
                            <Row className="Deliverable__leftItem">
                              <Col xs={12}>
                                <p className="Deliverable__synopsis">{deliverable.synopsis}</p>
                              </Col>
                            </Row>

                            {/* Component attributes */}
                            {deliverable.attributes.map((attr, index) => {
                              return (
                                <Row className="Deliverable__leftItem" key={index}>
                                  <Col xs={12}>
                                    <div className="Deliverable__item__subtitle">
                                      <span className="Deliverable__item__iconCtn">
                                        <FontAwesomeIcon icon={getAttrHeadingIcon(attr.heading)} />
                                      </span>
                                      {attr.heading}
                                    </div>

                                    {attr.contents.constructor.name === "Array" &&
                                      <div className="Deliverable__attributeTags">
                                        {attr.contents.map((entry, index) => <div key={index} className="Deliverable__attributeTag">{entry}</div>)}
                                      </div>
                                    }

                                    {attr.contents.constructor.name === "String" &&
                                      <p className="Deliverable__synopsis">{attr.contents}</p>
                                    }
                                  </Col>
                                </Row>
                              );
                            })}
                          </Col>
                        </Row>


                      </div>
                    </Fragment>
                  )
                })
              }
            </div>
          </Col>
        </Row>



        {/* Next project button*/}
        <Row>
          <Col xs={12} className="FlexRowSpaceBetween">
            <Link className="jp-button" to={`/${props.project.category}/${props.navProjectIds.prev}`}>
              <FontAwesomeIcon icon={faArrowCircleLeft} /> Previous Project
            </Link>
            <Link className="jp-button" to={`/${props.project.category}/${props.navProjectIds.next}`}>
              Next Project <FontAwesomeIcon icon={faArrowCircleRight} />
            </Link>
          </Col>
        </Row>


      </div>
    )
  }

  if (props.loading) return renderLoader();
  else return renderDeliverableXs();
}

function isYoutubeVideo(url) {
  return url.indexOf('youtube.com') !== -1;
}

function isImage(url) {
  return (url.indexOf('.png') !== -1 || url.indexOf('.jpg') !== -1);
}

export default DeliverableXs;


// WEBPACK FOOTER //
// ./src/components/Project/DeliverableXs/DeliverableXs.js